import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FaqSection = () => {
  const [expanded, setExpanded] = useState<number | null>(0);

  const faqs = [
    { question: "Comment signaler un problème dans ma ville ?",
      answer: "Cliquez sur le bouton 'Nouveau signalement', remplissez le formulaire avec les détails du problème, ajoutez une photo si possible, et soumettez votre signalement. Vous recevrez des notifications sur l'avancement de la résolution." },
    { question: "Comment suivre l'état de mon signalement ?",
      answer: "Tous vos signalements sont visibles dans votre tableau de bord personnel. Vous recevrez également des notifications automatiques lorsque le statut de votre signalement change." },
    { question: "Les mairies peuvent-elles utiliser cette plateforme ?",
      answer: "Absolument ! Nous proposons un accès dédié pour les communes avec des tableaux de bord de gestion spécifiques. Consultez notre page 'Contribuer' pour plus d'informations sur les solutions pour collectivités." },
    { question: "Comment soutenir cette application ?",
      answer: "Vous pouvez contribuer en parrainant de nouveaux utilisateurs, en souscrivant à un abonnement premium pour des fonctionnalités avancées, ou en partageant l'application avec vos amis et votre municipalité." },
  ];

  return (
    <div className="grid md:grid-cols-12 gap-10 md:gap-16">
      <div className="md:col-span-4 md:sticky md:top-32 md:self-start">
        <span className="ed-eyebrow">04 — F.A.Q</span>
        <h2 className="ed-heading text-3xl md:text-5xl mt-5 mb-5">
          Questions <span className="accent">fréquentes</span>
        </h2>
        <p className="ed-subtle text-base max-w-sm">
          Tout ce que vous devez savoir pour commencer à signaler avec confiance.
        </p>
      </div>

      <div className="md:col-span-8">
        <div className="border-t border-[var(--ed-rule)]" />
        {faqs.map((faq, index) => {
          const open = expanded === index;
          return (
            <div key={index} className="border-b border-[var(--ed-rule)]">
              <button
                className="w-full py-7 text-left flex items-start gap-5 group"
                onClick={() => setExpanded(open ? null : index)}
              >
                <span className="font-display text-xs text-[var(--ed-navy-500)] tracking-widest mt-1.5 shrink-0 w-6">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <span className="flex-1">
                  <span className="font-display font-semibold text-lg md:text-xl text-[var(--ed-ink)] group-hover:text-[var(--ed-navy-700)] transition-colors">
                    {faq.question}
                  </span>
                  <div
                    className={`overflow-hidden transition-all duration-500 ${open ? 'max-h-60 pt-4' : 'max-h-0'}`}
                  >
                    <p className="ed-subtle text-base leading-relaxed max-w-2xl">
                      {faq.answer}
                    </p>
                  </div>
                </span>
                <span className="mt-1.5 shrink-0">
                  {open ? (
                    <Minus className="h-4 w-4 text-[var(--ed-navy-800)]" />
                  ) : (
                    <Plus className="h-4 w-4 text-[var(--ed-ink)]/60 group-hover:text-[var(--ed-navy-700)] transition-colors" />
                  )}
                </span>
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FaqSection;
